import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { FileCheck, CreditCard } from 'lucide-react'
import { withNamespaces } from 'react-i18next'

import AppRentalHeader from '../containers/AppRentalHeader'
import { postRedsys, postGpPayment } from '../actions/qrs'
import { fetchCustomer } from '../actions/qrs'
import NmStepBarRental from '../components/NmStepBarRental'
import { currencySymbol } from '../utils/currency';

// Addon Payments (Comercia Global Payments): the HPP posts its result here;
// the endpoint validates it server-side and bounces back to the rental ticket.
const GP_RESPONSE_URL = 'https://lockers-qr-api.vacway.es/v1/qrs/gp-response'

class PaymentRentalView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      redsys: null,
      iva: 21,
      redsysSignature: null,
      redsysMerchant: null,
      redsysVersion: null,
      total: null,
      importeBase: null,
      importeIva: null,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      showExitDialog: false,
      newLockerPrice: 0,
      discountApplied: false,
      timeStamp: null,
      // Addon Payments (HPP) state
      paymentId: null,
      redsysURLOK: null,
      gpJson: null,
      gpUrl: null,
      gpScriptLoaded: false,
      gpInitialized: false,
      gpError: null,
    }

    this._paymentSubmitted = false
    this._skipUnmountRedirect = false
    this._unblockHistory = null
    this.countdownInterval = null

    this.getLockerType = this.getLockerType.bind(this)
  }

  componentDidMount() {
    const {
      selectedLocker, lockerPrice, lockerAssigned, prerentCode, prerentTime, totalDays,
      startDate, endDate, qrType, qr, timeStamp, customerName, mail, phoneNumber,
      idNumber, customerId, zoneSelected, descriptionZone
    } = this.props.location.state

    const { t, i18n } = this.props

    let language = '001'
    switch (i18n.language) {
      case 'es': language = '001'; break
      case 'en': language = '002'; break
      case 'it': language = '007'; break
      case 'gr': language = '005'; break
      case 'fr': language = '004'; break
      case 'pt': language = '009'; break
    }

    const newLockerPrice = lockerPrice
    this.setState({ newLockerPrice, timeStamp }, () => { this.startCountdown() })

    this._unblockHistory = history.block(() => {
      this.setState({ showExitDialog: true })
      return false
    })

    window.addEventListener('beforeunload', this._onBeforeUnload)

    const paymentProvider = this.props.qrData?.PaymentProvider || 'redsys'
    const useInsite = this.props.qrData?.useRedsysInsite || false
    this._isAddon = paymentProvider === 'addon'

    // Addon Payments requires a globally unique ORDER_ID per attempt
    const paymentId = this._isAddon
      ? `GP${Date.now()}${Math.floor(Math.random() * 900 + 100)}`
      : Math.floor(Math.random() * 1000000 + 1).toString()
    const redsysURLOK = `https://lockers-qr.vacway.es/ticketRentalView?lockerPrice=${newLockerPrice}&descriptionZone=${descriptionZone}&zoneSelected=${zoneSelected}&selectedLocker=${selectedLocker}&lockerAssigned=${lockerAssigned}&paymentId=${paymentId}&qrToken=${qr}&language=${i18n.language}&prerentCode=${prerentCode}&startDate=${startDate.toLocaleDateString('es-ES')}&endDate=${endDate.toLocaleDateString('es-ES')}&customerName=${encodeURIComponent(customerName)}&mail=${encodeURIComponent(mail)}&phoneNumber=${encodeURIComponent(phoneNumber)}&customerId=${customerId}&idNumber=${encodeURIComponent(idNumber || '')}`
    const redsysURLKO = `https://lockers-qr.vacway.es/paymentRentalError?qr=${qr}&language=${i18n.language}`

    this.setState({ paymentId, redsysURLOK })

    if (this._isAddon) {
      // ── Addon Payments (HPP) ─────────────────────────────────────────────
      // Credentials are resolved server-side (Customer.AddonPayments); the
      // browser only sends amount + identifiers and gets the signed JSON back.
      if (qrType === 'free') {
        this.TotalComponent()
        this.setState({ redsys: { free: true } })
        return
      }

      if (useInsite) this.loadGpScript()

      this.props.postGpPayment({
        customerId,
        price: Number(newLockerPrice.toFixed(2)),
        paymentId,
        urlOk: redsysURLOK,
        urlKo: redsysURLKO,
        isTest: qrType === 'test',
        // HPP_LANG takes ISO codes; the app's own code for German is 'gr'
        language: i18n.language === 'gr' ? 'de' : i18n.language,
        customerEmail: mail,
        customerPhone: phoneNumber ? `+${phoneNumber}` : undefined,
      })
        .then(answer => {
          const gp = answer && answer.response
          if (!gp || gp.error || !gp.hppJson) {
            console.error('[GP] payment init failed:', gp)
            this.TotalComponent()
            this.setState({ gpError: (gp && gp.error) || 'No se pudo iniciar el pago' })
            return
          }
          this.TotalComponent()
          this.setState({ redsys: gp, gpJson: gp.hppJson, gpUrl: gp.hppUrl })
        })
        .catch(error => {
          console.error('[GP] payment init error:', error)
          this.TotalComponent()
          this.setState({ gpError: 'No se pudo iniciar el pago' })
        })
      return
    }

    const redsysPetition = {
      price: Number(newLockerPrice.toFixed(2)),
      redsysURLOK,
      redsysURLKO,
      paymentId,
      merchantCode: '351639505',
      currency: '978',
      terminal: '1',
      merchantUrl: 'https://vacway.com',
      secretKey: 'xhI+J4wrx0JKkeGqJ12j2+ErLNH9OpHM',
      language,
    }

    this.props.fetchCustomer(customerId)
      .then(customer => {
        redsysPetition.merchantCode = customer.response.Redsys.MERCHANTCODE
        redsysPetition.currency = customer.response.Redsys.CURRENCY
        redsysPetition.terminal = customer.response.Redsys.TERMINAL
        redsysPetition.merchantUrl = customer.response.Redsys.MERCHANTURL
        redsysPetition.secretKey = customer.response.Redsys.SECRETKEY

        return this.props.postRedsys(redsysPetition)
      })
      .then(answer => {
        const answerRedsys = answer.response
        this.TotalComponent()
        this.setState({
          redsys: answerRedsys,
          redsysSignature: answerRedsys.Ds_Signature,
          redsysMerchant: answerRedsys.Ds_MerchantParameters,
          redsysVersion: answerRedsys.Ds_SignatureVersion,
        })
      })
      .catch(console.error)
  }

  componentDidUpdate() {
    if (!this._isAddon) return
    const useInsite = this.props.qrData?.useRedsysInsite || false
    const { gpScriptLoaded, gpJson, gpUrl } = this.state
    if (useInsite && !this._gpInitStarted && gpScriptLoaded && gpJson && gpUrl) {
      this._gpInitStarted = true
      this.initGpEmbedded()
    }
  }

  componentWillUnmount() {
    clearInterval(this.countdownInterval)
    if (this._unblockHistory) this._unblockHistory()
    window.removeEventListener('beforeunload', this._onBeforeUnload)

    const gpScript = document.getElementById('gp-hpp-script')
    if (gpScript) gpScript.remove()
    if (this._gpMessageHandler) {
      window.removeEventListener('message', this._gpMessageHandler)
      this._gpMessageHandler = null
    }

    if (!this._skipUnmountRedirect && !this._paymentSubmitted) {
      const { qr } = this.props.location.state
      history.push(`/qrsale/${qr}`)
    }
  }

  // ─── Addon Payments (HPP) ──────────────────────────────────────────────────

  loadGpScript() {
    if (document.getElementById('gp-hpp-script') || window.RealexHpp) {
      this.setState({ gpScriptLoaded: true })
      return
    }
    const script = document.createElement('script')
    script.id = 'gp-hpp-script'
    script.src = '/lib/rxp-js.js'
    script.onload = () => this.setState({ gpScriptLoaded: true })
    script.onerror = () => this.setState({ gpError: 'Error al cargar el formulario de pago' })
    document.head.appendChild(script)
  }

  initGpEmbedded() {
    const { gpJson, gpUrl } = this.state
    if (!document.getElementById('gp-pay-button') || !document.getElementById('gp-hpp-frame') || !window.RealexHpp) {
      this.setState({ gpError: 'Error al inicializar el formulario de pago' })
      return
    }
    try {
      // Release the navigation guards when the HPP reports the payment result,
      // BEFORE rxp-js does its top-level response POST — the customer must not
      // get a "leave site?" prompt mid-payment. Resize events (data with an
      // `iframe` key) mean the form is still open.
      this._gpMessageHandler = (ev) => {
        const origin = ev.origin || ''
        if (origin.indexOf('addonpayments.com') === -1 && origin.indexOf('realexpayments.com') === -1) return
        let parsed = null
        try { parsed = JSON.parse(ev.data) } catch (e) { return }
        if (parsed && parsed.iframe) return
        this._paymentSubmitted = true
        this._skipUnmountRedirect = true
        if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
        window.removeEventListener('beforeunload', this._onBeforeUnload)
      }
      window.addEventListener('message', this._gpMessageHandler)

      window.RealexHpp.setHppUrl(gpUrl)
      window.RealexHpp.embedded.init('gp-pay-button', 'gp-hpp-frame', GP_RESPONSE_URL, gpJson)
      this.setState({ gpInitialized: true })
      // Open the HPP form right away: the hidden trigger button is only
      // rxp-js's attach point — the customer's single action is the form
      // itself inside the iframe.
      setTimeout(() => {
        const btn = document.getElementById('gp-pay-button')
        if (btn) btn.click()
      }, 0)
    } catch (err) {
      console.error('[GP] embedded init error:', err)
      this.setState({ gpError: 'Error al inicializar el formulario de pago' })
    }
  }

  gpPaymentForm() {
    const { redsys, gpJson, gpUrl, gpInitialized, gpError, redsysURLOK } = this.state
    const { qrType } = this.props.location.state
    const { t } = this.props
    const useInsite = this.props.qrData?.useRedsysInsite || false

    // 'free' QRs skip the gateway entirely (same behaviour as the Redsys path)
    if (qrType === 'free' && redsys && redsys.free) {
      const handleFreeClick = () => {
        this._paymentSubmitted = true
        this._skipUnmountRedirect = true
        if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
        window.location.href = redsysURLOK
      }
      return (
        <div className="nm-pay-form-wrap">
          <input type="button" value={t('Reservar')} className="nm-redsys-btn" onClick={handleFreeClick} />
        </div>
      )
    }

    if (gpError) {
      return <div className="alert alert-danger mt-2" style={{ fontSize: '13px' }}>{gpError}</div>
    }

    if (!gpJson || !gpUrl) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
    }

    if (useInsite) {
      // In-site mode: the HPP form opens automatically inside this iframe
      return (
        <div className="nm-pay-form-wrap">
          {!gpInitialized && (
            <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
          )}
          <button type="button" id="gp-pay-button" style={{ display: 'none' }} />
          <iframe
            id="gp-hpp-frame"
            title="Pago seguro"
            style={{
              display: 'none',
              width: '100%',
              height: '640px',
              border: '1px solid rgba(10,29,61,0.15)',
              borderRadius: '12px',
              marginTop: '12px',
              background: '#ffffff',
            }}
          />
        </div>
      )
    }

    // Redirect mode: classic signed form POST to the HPP (Cyberpac-style)
    const onSubmit = () => {
      this._paymentSubmitted = true
      this._skipUnmountRedirect = true
      if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
    }
    return (
      <div className="nm-pay-form-wrap">
        <form action={gpUrl} method="POST" acceptCharset="UTF-8" name="peticionGp" onSubmit={onSubmit}>
          {Object.entries(gpJson).map(([key, value]) => (
            <input type="hidden" name={key} value={String(value)} key={key} />
          ))}
          <input type="submit" value={qrType === 'test' ? t('TEST') : t('Pagar')} className="nm-redsys-btn" />
        </form>
      </div>
    )
  }

  _onBeforeUnload = (e) => {
    if (!this._paymentSubmitted) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  startCountdown = () => {
    const { timeStamp } = this.state
    const endTime = new Date(timeStamp).getTime() + 5 * 60 * 1000

    this.countdownInterval = setInterval(() => {
      const diff = endTime - Date.now()
      if (diff <= 0) {
        clearInterval(this.countdownInterval)
        this.setState({ minutes: 0, seconds: 0, isTimeUp: true })
      } else {
        this.setState({
          minutes: Math.floor(diff / (60 * 1000)),
          seconds: Math.floor((diff % (60 * 1000)) / 1000),
        })
      }
    }, 250)
  }

  TotalComponent() {
    const { iva, newLockerPrice } = this.state
    const importeBase = (newLockerPrice / (1 + iva / 100)).toFixed(2)
    const importeIva = (newLockerPrice - importeBase).toFixed(2)
    const total = newLockerPrice.toFixed(2)
    this.setState({ importeBase, importeIva, total })
    return { total, importeBase, importeIva, iva }
  }

  handleLeave() {
    this._skipUnmountRedirect = true
    if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
    const { qr } = this.props.location.state
    history.push(`/qrsale/${qr}`)
  }

  goToPhoneView() {
    this._skipUnmountRedirect = true
    if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
    const { zoneSelected, descriptionZone, selectedLocker, lockerPrice, lockerAssigned,
      prerentCode, prerentTime, totalDays, startDate, endDate, qrType, qr,
      timeStamp, customerId, customerName, phoneNumber, mail, idNumber,
      newsletterAcceptance, confirmReservation } = this.props.location.state
    this.props.push('/PhoneRentalView', {
      zoneSelected, descriptionZone, selectedLocker, lockerPrice, lockerAssigned,
      prerentCode, prerentTime, totalDays, startDate, endDate, qrType, qr,
      timeStamp, customerId, customerName, phoneNumber, mail, idNumber,
      newsletterAcceptance, confirmReservation,
    })
  }

  getLockerType(type) {
    const map = {
      BNS: 'Standard', CNS: 'Standard Carga', BWS: 'Standard XL', CWS: 'Standard Carga XL',
      BNM: 'Medium', CNM: 'Medium Carga', BWM: 'Medium XL', CWM: 'Medium Carga XL',
      BNL: 'Large', CNL: 'Large Carga', BWL: 'Large XL', CWL: 'Large Carga XL',
      BNXL: 'Large', CNXL: 'Large Carga', BWXL: 'Large XL', CWXL: 'Large Carga XL',
      BN2XL: 'Large', CN2XL: 'Large Carga', BW2XL: 'Large XL', CW2XL: 'Large Carga XL',
      BN3XL: 'Ski', CN3XL: 'Ski Carga', BW3XL: 'Ski XL', CW3XL: 'Ski Carga XL',
    }
    return map[type] || 'None'
  }

  redsysForm() {
    if (this._isAddon) {
      return this.gpPaymentForm()
    }

    const { redsys, redsysSignature, redsysMerchant, redsysVersion } = this.state
    const { descriptionZone, zoneSelected, selectedLocker, lockerAssigned, qr, qrType,
      prerentCode, startDate, endDate, customerName, mail, phoneNumber, customerId, idNumber } = this.props.location.state
    const { t, i18n } = this.props
    const { newLockerPrice } = this.state

    const paymentId = Math.floor(Math.random() * 1000000 + 1).toString()
    const productionUrl = 'https://sis.redsys.es/sis/realizarPago'
    const testUrl = 'https://sis-t.redsys.es:25443/sis/realizarPago'

    let redsysURLOK = `https://lockers-qr.vacway.es/TicketRentalView?descriptionZone=${descriptionZone}&zoneSelected=${zoneSelected}&selectedLocker=${selectedLocker}&lockerAssigned=${lockerAssigned}&lockerPrice=${newLockerPrice}&paymentId=${paymentId}&qrToken=${qr}&language=${i18n.language}&prerentCode=${prerentCode}&startDate=${startDate.toLocaleDateString('es-ES')}&endDate=${endDate.toLocaleDateString('es-ES')}&customerName=${encodeURIComponent(customerName)}&mail=${encodeURIComponent(mail)}&phoneNumber=${encodeURIComponent(phoneNumber)}&customerId=${customerId}&idNumber=${encodeURIComponent(idNumber || '')}`

    const handleFreeClick = () => {
      this._paymentSubmitted = true
      this._skipUnmountRedirect = true
      if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
      window.location.href = redsysURLOK
    }

    const onSubmit = () => {
      this._paymentSubmitted = true
      this._skipUnmountRedirect = true
      if (this._unblockHistory) { this._unblockHistory(); this._unblockHistory = null }
    }

    if (!redsys || !redsysSignature || !redsysMerchant || !redsysVersion) {
      return <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
    }

    const actionUrl = qrType === 'test' ? testUrl : productionUrl

    if (qrType === 'free') {
      return (
        <div className="nm-pay-form-wrap">
          <form method="POST" acceptCharset="UTF-8" name="peticionRedsys">
            <input type="hidden" name="Ds_SignatureVersion" value={redsysVersion} />
            <input type="hidden" name="Ds_MerchantParameters" value={redsysMerchant} />
            <input type="hidden" name="Ds_Signature" value={redsysSignature} />
            <input type="button" value={t('Reservar')} className="nm-redsys-btn" onClick={handleFreeClick} />
          </form>
        </div>
      )
    }

    return (
      <div className="nm-pay-form-wrap">
        <form action={actionUrl} method="POST" acceptCharset="UTF-8" name="peticionRedsys" onSubmit={onSubmit}>
          <input type="hidden" name="Ds_SignatureVersion" value={redsysVersion} />
          <input type="hidden" name="Ds_MerchantParameters" value={redsysMerchant} />
          <input type="hidden" name="Ds_Signature" value={redsysSignature} />
          <input type="submit" value={qrType === 'test' ? t('TEST') : t('Pagar')} className="nm-redsys-btn" />
        </form>
      </div>
    )
  }

  renderTimeoutDialog() {
    const { t } = this.props
    return (
      <div className="nm-exit-overlay">
        <div className="nm-exit-dialog">
          <span className="nm-exit-dialog-icon">⏰</span>
          <h4 className="nm-exit-dialog-title">{t('Tiempo de reserva agotado')}</h4>
          <p className="nm-exit-dialog-body">
            {t('Lo sentimos, pero no podemos reservar tu taquilla por más tiempo. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.')}
          </p>
          <div className="nm-exit-dialog-actions">
            <button className="nm-exit-btn-leave" onClick={() => this.handleLeave()}>
              {t('Volver al inicio')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderExitDialog() {
    const { t } = this.props
    return (
      <div className="nm-exit-overlay">
        <div className="nm-exit-dialog">
          <span className="nm-exit-dialog-icon">🚪</span>
          <h4 className="nm-exit-dialog-title">{t('¿Cancelar la compra?')}</h4>
          <p className="nm-exit-dialog-body">
            {t('Si sales ahora perderás la pre-reserva de taquillas. La selección se liberará automáticamente.')}
          </p>
          <div className="nm-exit-dialog-actions">
            <button className="nm-exit-btn-stay" onClick={() => this.setState({ showExitDialog: false })}>
              {t('Continuar con el pago')}
            </button>
            <button className="nm-exit-btn-leave" onClick={() => this.handleLeave()}>
              {t('Salir')}
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { t } = this.props
    const { redsys, iva, importeBase, importeIva, total, minutes, seconds, isTimeUp, discountApplied, showExitDialog } = this.state
    const { descriptionZone, selectedLocker, lockerAssigned, startDate, endDate, customerName, mail, phoneNumber, lockerPrice } = this.props.location.state

    if (!redsys && !this.state.gpError) {
      return <div className="rentalBackground spinner"><img src="/images/logo.png" alt="Logo" /></div>
    }

    const lockerCount = typeof lockerAssigned === 'string'
      ? lockerAssigned.split(',').filter(Boolean).length
      : lockerAssigned.length

    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <NmStepBarRental step={4} />
        <div className="nm-page">

          {/* Timer banner */}
          <div className={`nm-phone-timer${minutes === 0 && seconds < 60 ? ' nm-phone-timer-urgent' : minutes < 2 ? ' nm-phone-timer-warning' : ''}`}>
            <div className="nm-phone-timer-left">
              <CreditCard size={20} />
              <span className="nm-phone-timer-label">{t('Tiempo para confirmar el pago')}</span>
            </div>
            <span className="nm-phone-timer-count">
              {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
            </span>
          </div>

          {/* Main card */}
          <div className="nm-form">
            <div className="nm-pay-card-inner">

              {/* Left column: booking summary */}
              <div className="nm-pay-card-left">
                <FileCheck className="nm-form-icon" strokeWidth={1} />
                <p style={{ textAlign: 'center', fontSize: '0.88rem', color: '#6b7280', margin: '0 0 12px' }}>
                  {t('Revisa los datos de tu reserva')}
                </p>

                <div className="nm-pay-fields">
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Zona')}</span>
                    <span className="nm-pay-field-value">{descriptionZone}</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Taquilla')}</span>
                    <span className="nm-pay-field-value">{this.getLockerType(selectedLocker)}</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Cantidad')}</span>
                    <span className="nm-pay-field-value">{lockerCount}</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Inicio')}</span>
                    <span className="nm-pay-field-value">{startDate ? startDate.toLocaleDateString() : ''}</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Fin')}</span>
                    <span className="nm-pay-field-value">{endDate ? endDate.toLocaleDateString() : ''}</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Hora Límite')}</span>
                    <span className="nm-pay-field-value">23:59</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Nombre')}</span>
                    <span className="nm-pay-field-value">{customerName}</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Email')}</span>
                    <span className="nm-pay-field-value">{mail}</span>
                  </div>
                  <div className="nm-pay-field">
                    <span className="nm-pay-field-label">{t('Teléfono')}</span>
                    <span className="nm-pay-field-value">+{phoneNumber}</span>
                  </div>
                </div>
              </div>

              <div className="nm-pay-col-sep" />

              {/* Right column: price + pay button */}
              <div className="nm-pay-card-right">
                <CreditCard className="nm-form-icon" strokeWidth={1} />
                <p style={{ textAlign: 'center', fontSize: '0.88rem', color: '#6b7280', margin: '0 0 12px' }}>
                  {t('Confirma los importes')}
                </p>

                {discountApplied && (
                  <div className="nm-pay-price-row">
                    <span className="nm-pay-price-label">{t('Importe Original')}</span>
                    <span className="nm-pay-price-value">{lockerPrice.toFixed(2)} {currencySymbol()}</span>
                  </div>
                )}

                <div className="nm-pay-price-row">
                  <span className="nm-pay-price-label">{t('Base')}</span>
                  <span className="nm-pay-price-value">{importeBase} {currencySymbol()}</span>
                </div>
                <div className="nm-pay-price-row">
                  <span className="nm-pay-price-label">{t('IVA')} ({iva}%)</span>
                  <span className="nm-pay-price-value">{importeIva} {currencySymbol()}</span>
                </div>

                <div className="nm-pay-price-total-row">
                  <span className="nm-pay-price-total-label">{t('Total')}</span>
                  <span className="nm-pay-price-total-amount">{total} {currencySymbol()}</span>
                </div>

                {this.redsysForm()}
              </div>
            </div>
          </div>

          {/* Edit data / cancel actions */}
          <div className="nm-pay-actions-card">
            <p className="nm-pay-actions-hint">{t('¿Necesitas cambiar algo?')}</p>
            <div className="nm-pay-actions-row">
              <button className="nm-pay-action-edit" onClick={() => this.goToPhoneView()}>
                ✏️ {t('Cambiar datos')}
              </button>
              <button className="nm-pay-action-cancel" onClick={() => this.setState({ showExitDialog: true })}>
                ✕ {t('Cancelar')}
              </button>
            </div>
          </div>

        </div>

        {isTimeUp && this.renderTimeoutDialog()}
        {showExitDialog && !isTimeUp && this.renderExitDialog()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  redsys: state.redsys,
  qrData: state.qrs.qr,
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postRedsys: bindActionCreators(postRedsys, dispatch),
  postGpPayment: bindActionCreators(postGpPayment, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentRentalView))
